import React from "react";
import style from "../../Styles/Components/Title.module.css";

const Title = ({ title }) => (
  <div className={style.container}>
    <span className={style.title}>{title}</span>
  </div>
);

export default Title;
